import { get, put, del, fetchWithAuth } from '../utils/httpInterceptor';
import { getCompanyId } from '../utils/companyHelper';
import { buildCrudQueryParams } from './filterQueryBuilder';

class StayService {

    static async getAll(page, size, filters = {}, sortConfig = {}) {
        const companyId = getCompanyId();
        const queryParams = buildCrudQueryParams({
            page,
            size,
            filters,
            sortConfig,
            companyId,
            sortMode: 'split',
        });
        return await get(`/stay?${queryParams.toString()}`);
    }

    static async createStay(newStay) {
        const companyId = getCompanyId();
        let stayData = newStay;
        if (stayData instanceof FormData) {
            if (companyId) {
                stayData.append('companyId', companyId);
            }
        } else {
            stayData = {
                ...stayData,
                companyId: companyId
            };
        }

        const response = await fetchWithAuth('/stay', {
            method: 'POST',
            body: stayData,
        });
        return await response.json();
    }

    static async updateStay(stayId, updatedStay) {
        const companyId = getCompanyId();
        let stayData = updatedStay;
        if (stayData instanceof FormData) {
            if (companyId) {
                stayData.append('companyId', companyId);
            }
        } else {
            stayData = {
                ...stayData,
                companyId: companyId
            };
        }

        return await fetchWithAuth(`/stay/${stayId}`, {
            method: 'PUT',
            body: stayData,
        });
    }

    static async deleteStay(stayId) {
        return await del(`/stay/${stayId}`);
    }

    static async updateEnabled(stayId, updatedStay) {
        const companyId = getCompanyId();
        const stayData = {
            ...updatedStay,
            companyId: companyId
        };
        return await put(`/stay/enabled/${stayId}`, stayData);
    }

    static async create(newStay) {
        return this.createStay(newStay);
    }

    static async update(stayId, updatedStay) {
        return this.updateStay(stayId, updatedStay);
    }

    static async delete(stayId) {
        return this.deleteStay(stayId);
    }
}

export default StayService;
